<template>
<div>
    <a-modal v-model="salaryEditVisit" :title="audit?'项目金额调整详情':'项目金额调整'" @ok="salaryEditOk" width="60%">
        <template slot="footer">
				<a-button key="back" @click="salaryEditOk"> 关闭 </a-button>
                <!-- <a-button type="primary" key="back" @click="exportEvent"> 导出 </a-button> -->
                <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
                <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
                <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
			</template>
        <a-form-model :model="salaryForm" ref="salaryForm" :rules="rules" >
            <a-row><span class="form_title2" style="margin 10px 0;font-size: 18px;font-weight: 700;">表单信息:</span></a-row>
              <a-row>
					<a-col :span="8">
						<a-form-model-item label="项目名称" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
							<a-input v-model="salaryForm.projectName" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="业务员" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
							<a-input v-model="salaryForm.salesmen" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="项目类型" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
							<a-input v-model="salaryForm.type" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                </a-row>
				<a-row>
                    <a-col :span="8">
						<a-form-model-item label="业务来源" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
							<a-input v-model="salaryForm.businessSource" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                <a-col :span="8">
                    <a-form-model-item label="项目编号" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.identifier" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item label="隶属公司" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.companyOrder" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row><span class="form_title2" style="margin 10px 0;font-size: 18px;font-weight: 700;">修改前费用明细:</span></a-row>
            <a-row>
                <a-col :span="8">
                    <a-form-model-item label="项目金额" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                        <a-input v-model="salaryForm.totalMoney" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item label="业务宣传费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.commission" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item label="评审费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.evaluationFee" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="8">
                    <a-form-model-item label="服务费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.serviceCharge" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
           
                <a-col :span="8">
                    <a-form-model-item label="分包费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.subprojectFee" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item label="虚拟税费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.virtualTax" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="8">
                    <a-form-model-item label="其他支出" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.otherExpenses" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row><span class="form_title2" style="margin 10px 0;font-size: 18px;font-weight: 700;">修改后费用明细:</span></a-row>
            <a-row>
                <a-form-model-item label="抄送人" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                   <span style="margin 10px 0;">{{salaryForm.ccName}}</span>
                </a-form-model-item>
            </a-row>
              <!-- <a-row>
					<a-col :span="8">
						<a-form-model-item label="项目名称" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"   >
							<a-input v-model="salaryForm.projectName" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="业务员" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"   >
							<a-input v-model="salaryForm.salesmen" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="项目类型" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
							<a-input v-model="salaryForm.type" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                </a-row>
				<a-row>
                    <a-col :span="8">
						<a-form-model-item label="业务来源" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"   >
							<a-input v-model="salaryForm.businessSource" allowClear placeholder="请输入" disabled></a-input>
						</a-form-model-item>
					</a-col>
                <a-col :span="8">
                    <a-form-model-item label="项目编号" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"   >
                        <a-input v-model="salaryForm.identifier" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item label="隶属公司" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.companyOrder" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
            </a-row> -->
			<a-row>
                <a-col :span="8">
                    <a-form-model-item label="项目金额" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.newTotalMoney" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item label="业务宣传费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.newCommission" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item label="评审费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.newEvaluationFee" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
            </a-row>
			<a-row>
                <a-col :span="8">
                    <a-form-model-item label="服务费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.newServiceCharge" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item label="分包费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"  >
                        <a-input v-model="salaryForm.newSubprojectFee" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item label="虚拟税费" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.newVirtualTax" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
             </a-row>
			<a-row>
                <a-col :span="8">
                    <a-form-model-item label="其他支出" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
                        <a-input v-model="salaryForm.newOtherExpenses" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
                    <a-form-model-item label="修改结果" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                        <a-input v-model="salaryForm.upResult" allowClear  disabled></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="8">
						<a-form-model-item label="修改原因" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" >
							<a-textarea :auto-size="{ minRows: 2, maxRows: 10 }" v-model="salaryForm.remark" allowClear placeholder="请输入" disabled ></a-textarea>
						</a-form-model-item>
				</a-col>
               
            </a-row>
            <a-row>
                <a-col  :span="8">
                    <a-form-model-item label="附件(必填)" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                        <div
                            class="view_path"
                            style="color: #1191FF;"
                            @click="previewFile(item)"
                            v-for="(item, index) in salaryForm.attachment"
                            :key="index"
                            >
                                {{ item.name }}
                            </div>
					</a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
        <!-- <div class="bottom">
           <div> 附件：</div>
           <div class="center">
              
           </div>
        </div> -->
        <div class="bottom">
            <div style="color: #aaa">图片:</div>
            <div class="center">
                <div
                    class="view_path_img"
                    v-for="(item, index) in salaryForm.vouchers"
                    :key="index"
                    style="display: flex; justify-content: space-between"
                    >
                    <div class="view_path_img_margin"></div>
                    <div class="view_path_img_center">
                        <img :src="item.preUrl" @click="show_img(index, salaryForm.vouchers)" />
                    </div>
                    </div>
            </div>
                 
                        <!-- <div class="contentBox">
                              <div class="img_center"
                                v-for="(item, index) in salaryForm.vouchers" :key="index"
                              >
                                  <div>
                                      <img :src="item.preUrl" @click="show_img(index, salaryForm.vouchers)" />
                                      <div class="timeBox">{{item.createdTime}}</div>
                                  </div>
                              </div>
                        </div> -->
                    <!-- </a-form-model-item> -->
        </div>
        <preview ref="preview" />

        <div class="title" v-if="!audit && recordNumber == 1">
          <span>审批记录</span>
        </div>
        <div class="content" v-if="!audit && recordNumber == 1">
          <auditModel ref="auditModel"></auditModel>
        </div>
    </a-modal>
     <!-- 撤销提示 -->
    <preview ref="preview" />
    <a-modal
      v-model="is_revocation"
      :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
      on-ok="handleOkReason"
    >
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="comment" />
    </a-modal>
    <transferModal ref="transferModal" @sure="handleSure" />
</div>
  
</template>

<script>
import preview from '@/components/module/prview'
import auditModel from './audit.vue'
import { act_task_audit } from '@/api/activiti'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import { downLoadWordGet } from '@/utils/index'
import {salaryDetail, apply_downlodPdf} from '@/api/budget'
import { download_file_java } from '@/utils/request'
import { resolveBlob } from '@/utils/index'
const exportBaseUrl = process.env.VUE_APP_EXPORT_BASE_URL
export default {
    props: {
        audit: {
        type: Boolean,
        default: true,
        },
    },
    components: {
        preview,
        transferModal,
        auditModel
    },
    data(){
        return {
            recordNumber: 0,
            record: '',
            result: '',            
            is_revocation: false,
            salaryEditVisit: false,
            salaryForm: {

            }

        }
    },
    methods: {
        show_img(idx, imgs) {
            var row = {
                index: idx,
                imgs: imgs,
            }
            this.$refs.preview.show(row)
        },
        handleSure() {
            this.salaryEditVisit = false
            // this.is_show = false
            this.$emit('ok')
            },
        //预览文件
        async previewFile(file) {
        let path = '/' + file.url.split('/')[0] + '/'
        let fileName = file.url.substring(file.url.indexOf('/') + 1)
        var res = await download_file_java(file.types, path, fileName)
        var file_s_n = file.name.split('.')
        let type = file_s_n[file_s_n.length - 1]
        resolveBlob(res, this.get_file_type[type]) //新窗口打开，借用浏览器去打印
        },
        show(data) {
            this.recordNumber = data.recordNumber
            this.record = data
            this.salaryEditVisit = true
            //获得详情页面数据
            salaryDetail(data.businessKey).then(res => {
                if(res.code == 200) {
                    this.salaryForm = res.data
                    console.log(this.salaryForm, 'this.salaryForm====================')
                    // this.$message.success(res.msg)
                } else {
                    this.$message.error(res.msg)
                }
            })
            this.$nextTick(() => {
                if (!this.audit && this.recordNumber == 1) {
                this.$refs.auditModel.show(data)
                }
            })
            

        },
        salaryEditOk() {
            this.salaryEditVisit = false
            this.salaryForm = {}
        },
        // 导出
        exportEvent() {
            apply_downlodPdf({
                businessKey: this.record.businessKey,
            }).then((res) => {
                window.open(exportBaseUrl + '/file/download?path=' + res.data)
            })
        },
        handleOkReason() {
            if (this.result == 3) {
                if (this.comment == '') {
                this.$message.error('请输入驳回意见！')
                } else {
                this.succeed(this.result)
                }
            } else if (this.result == 2) {
                this.succeed(this.result)
            }
        },
        reject(result_) {
            if (result_ == 1) {
                this.$refs.transferModal.show({
                record: this.record,
                })
            } else {
                this.is_revocation = true
                this.comment = ''
                this.result = result_
            }
        },
        //审批
        succeed(result_) {
        act_task_audit({
            taskId: this.record.id,
            procDefKey: this.record.processDefKey,
            procInstId: this.record.procInstId,
            procName: this.record.processName,
            applyer: this.record.applyer,
            result: result_,
            businessKey: this.record.businessKey,
            comment: this.comment,
        }).then((res) => {
            if (res.code != 200) {
            this.$message.error(res.msg)
            return
            }
            this.salaryEditVisit = false
            this.$message.success('审批成功')
            this.$emit('ok')
            // this.is_show = false
            this.salaryEditVisit = false
            this.is_revocation = false
        })
        },

    },


}
</script>

<style lang="less" scoped>
.bottom {
    // display: flex;
    // justify-content: space-between;
    margin-left: 18px;
    .center {
        padding: 5px 10px;
        width: 100%;
        display: inline-block;
        margin-top: 10px;
    }
  
}

</style>